
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.62 8.78l.046.02-.046-.02a.798.798 0 101.463.639 6.457 6.457 0 0110.953-1.455l-2.422-.481a.798.798 0 10-.312 1.566l4.19.833a.798.798 0 00.94-.627l.833-4.19a.798.798 0 00-.627-.939l-.01.05.01-.05a.798.798 0 00-.94.627l.05.01-.05-.01-.434 2.19A8.053 8.053 0 004.62 8.78zm5.705 7.11a.798.798 0 00-.627-.939l-4.19-.833-.01.049.01-.049a.798.798 0 00-.94.627l-.833 4.19a.798.798 0 001.566.312l-.049-.01.05.01.435-2.192A8.068 8.068 0 0012 20.05a8.053 8.053 0 007.38-4.83.796.796 0 00-.412-1.05.798.798 0 00-1.051.411A6.457 6.457 0 0112 18.454a6.469 6.469 0 01-5.035-2.419l2.421.482.01-.049-.01.049a.798.798 0 00.939-.627z"}})])
          )
        }
      }
    